import "antd/dist/reset.css";
import { Collapse, Divider, Descriptions } from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";


const { Panel } = Collapse;

let componentsArray = [];

const iterateSummary = (sumVal, completion_date, iteration) => {
  let content = "";
  if (sumVal.values.length>0) {
    content = sumVal.values.filter((item) => item.is_selected).map((item) => item.selected_value).join(" | ");
    } else {
      content =  sumVal.comments || "";
    }
  let answers = {
      key: sumVal.title,
      label: sumVal.title,
      content: content,
    };

  const isValid = answers.content != "" ? true : false;

  if (isValid) {
    componentsArray.push(
      <div key={`sub-header-desc_${completion_date}_${iteration}`}>
        <Descriptions
          bordered
          layout="horizontal"
          column={1}
          labelStyle={{ width: "50%" }}
        >
              {answers?.content && (
                <Descriptions.Item key={answers.key} label={answers?.label}>
                  {answers?.content}
                </Descriptions.Item>
              )}
        </Descriptions>
      </div>
    );
  }
  return true;

};

const transformSummaries = (summaries) => {
  return Object.entries(summaries).map(([sumKey, sumVal], index) => {
    if (typeof sumVal === "object") {
      let tmp = iterateSummary(sumVal, summaries.completion_date, index);
      return tmp;
    }
    return true;
  });
};

const DOTSNewSummaryChild = (props) => {
  componentsArray = [];
  // componentsArray.push(
  //   <div key={props.data.completion_date} className="main-header">
  //     {props.data.title}
  //   </div>
  // );
  const summaries = transformSummaries(props.data);

  return (
    <>
      {props.data?.completion_date && summaries.length > 0 ? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          expandIconPosition="start"
          ghost={true}
          className="mhe-list-container"
        >
          <Panel
            header={
              <div>
                {utils.FormatDate(props?.data?.completion_date, "DATE_14")},{" "}
                {utils.FormatDate(props?.data?.completion_date, "TIME_1")}
              </div>
            }
            extra={utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation,utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}
            key="1"
          >
            {componentsArray.map((item) => item)}
          </Panel>
        </Collapse>
      ) : null}
    </>
   
  );
};

export default DOTSNewSummaryChild;
